import {AbstractLayoutComponent} from '../abstract-layout.component';
import {Component} from '@angular/core';

@Component({
    templateUrl: './registration.component.html',
})
export class RegistrationComponent extends AbstractLayoutComponent {}
